var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 48,
    viewBox: "0 0 149 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.5907 0.84803L63.6597 47.2743H51.6503L61.585 0.84803H73.5907ZM124.12 30.8239L130.441 13.3926L134.079 30.8239H124.12ZM137.52 47.2743H148.627L138.932 0.84803H128.68C126.374 0.84803 124.43 2.18993 123.569 4.25415L105.547 47.2743H118.157L120.662 40.3393H136.07L137.52 47.2743ZM106.173 32.1161C106.225 19.8633 89.2299 19.188 89.3469 13.7144C89.3831 12.0487 90.9696 10.2777 94.4409 9.82513C96.1619 9.59971 100.903 9.42763 106.281 11.9029L108.39 2.05826C105.501 1.00966 101.783 1.10115e-06 97.1563 1.10115e-06C85.2856 1.10115e-06 76.9317 6.31079 76.8611 15.3466C76.7845 22.0303 82.8241 25.7598 87.3739 27.9806C92.0549 30.2552 93.6252 31.7164 93.6077 33.751C93.5742 36.8656 89.8743 38.2404 86.4164 38.2942C80.3802 38.3869 76.8773 36.6607 74.0846 35.3624L71.9081 45.5332C74.7141 46.8207 79.8937 47.9439 85.264 48C97.8814 48 106.135 41.7679 106.173 32.1161M56.4307 0.84803L36.9724 47.2743H24.2774L14.7019 10.2239C14.1203 7.94158 13.6154 7.10602 11.8474 6.14482C8.96099 4.57842 4.19369 3.10957 0 2.19737L0.284944 0.84803H20.7207C23.3255 0.84803 25.6669 2.58209 26.2583 5.58197L31.3155 32.4468L43.8143 0.84803H56.4307Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.0875125960a40ff7885f8a2fe81b2b48.svg";
export { ForwardRef as ReactComponent };